<template>
  <modal name="patient-condition-modal"
         :height="600"
         :width="`100%`"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :reset="true"
         :clickToClose="true"
         @before-open="beforeOpen">
    <div class="FloatMenu md_overlay md_overlay_0">
      <div class="modal modal_0">
        <vue-scroll>
          <div class="md_content">
          <LoadingOverlay :activeSyncProps="activeSync" :isFullPageProps="false"/>
            <h6 class="--blue70 mb10">{{ $t('patient.condition.title_modal') }}</h6>
          <div class="right_btn_container" style="margin-top: 0;">
            <div class="right_save_list_btn pointer right_btn" @click="checkValues">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                   v-tooltip="{
                    content: this.$t('status.save'),
                    boundariesElement: this.window.document.body
                   }"
                   width="24" height="24"
                   viewBox="0 0 172 172"
                   style="fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                   stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                   font-family="none" font-weight="none" font-size="none" text-anchor="none"
                   style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="#275cbb">
                    <path
                      d="M34.4,22.93333c-6.33533,0 -11.46667,5.13133 -11.46667,11.46667v103.2c0,6.33533 5.13133,11.46667 11.46667,11.46667h103.2c6.33533,0 11.46667,-5.13133 11.46667,-11.46667v-91.73333l-22.93333,-22.93333h-11.46667v34.4c0,3.1648 -2.56853,5.73333 -5.73333,5.73333h-51.6c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333v-34.4zM91.73333,22.93333v28.66667h11.46667v-28.66667zM57.33333,91.73333h57.33333c6.33533,0 11.46667,5.13133 11.46667,11.46667v34.4h-80.26667v-34.4c0,-6.33533 5.13133,-11.46667 11.46667,-11.46667z"></path>
                  </g>
                </g>
              </svg>
            </div>
            <div class="right_reset_list_btn pointer right_btn" style="padding-top: 2px;" @click="resetValue">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                   v-tooltip="{
                    content: this.$t('status.reset'),
                    boundariesElement: this.window.document.body
                   }"
                   width="20" height="19"
                   viewBox="0 0 172 172"
                   style="fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                   stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                   font-family="none" font-weight="none" font-size="none" text-anchor="none"
                   style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="#275cbb">
                    <path
                      d="M91.375,0c-39.25301,0 -64.37079,28.39964 -64.91346,66.15385h-23.15385c-1.31791,0 -2.6875,0.7494 -2.6875,2.06731c-0.67187,1.31791 -0.67187,2.63582 0,3.30769l39.69231,50.85577c0.67188,0.67188 1.36959,1.24038 2.6875,1.24038c1.31791,0 2.01563,-0.56851 2.6875,-1.24038l39.69231,-50.85577c0.67188,-0.67187 0.67188,-1.98978 0,-3.30769c-0.67187,-1.31791 -2.01562,-2.06731 -2.6875,-2.06731h-23.15385c0.4393,-49.84796 25.94471,-60.93389 31.83654,-65.53365c1.31791,-0.67187 1.31791,-0.62019 0,-0.62019zM129,48.58173c-0.98197,0 -2.01562,0.36178 -2.6875,1.03365l-39.69231,50.85577c-0.67187,1.31791 -0.62019,2.63582 -0.62019,3.30769c0.67188,1.31791 2.01563,2.06731 2.6875,2.06731h23.77404c-0.4393,49.84796 -25.94471,60.9339 -31.83654,65.53365c-1.31791,0.67188 -1.31791,0.62019 0,0.62019c39.25301,0 64.37079,-28.39964 64.91346,-66.15385h22.53365c1.31791,0 2.6875,-0.7494 2.6875,-2.06731c1.31791,-1.31791 1.29207,-2.63581 0.62019,-3.30769l-39.69231,-50.85577c-0.67187,-0.67187 -1.70553,-1.03365 -2.6875,-1.03365z"></path>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <span class="md_close">
            <img
                src="/images/union.svg"
                alt=""
                @click="modalClose"
            />
          </span>
          <KvTable :items="items"/>
        </div>
        </vue-scroll>
      </div>
    </div>
  </modal>
</template>

<script>
    import KvTable from '@/components/Table/kvTable';
    import _API from "@/api";
    import { _MMT_GRADE_RANGE, _MRS_RANGE, _YES_NO_RANGE } from '@/components/Table/static'
    import { mapActions } from 'vuex'
    import LoadingOverlay from "@/components/loadingOverlay/index";

    export default {
      name: 'patientConditionModal',
      components: {LoadingOverlay, KvTable, },
      props: [''],
      data() {
        const item = [
          {
            index: 0,
            keyTitle: this.$t('patient.condition.paralysis_part'),
            keyType: 'DefaultInput',
            class: '',
            keyRange: [],
            values: '',
            maxLength: 50,
          },
          {
            index: 1,
            keyTitle: this.$t('patient.condition.infection'),
            keyType: 'SelectBox',
            class: '',
            keyRange: _YES_NO_RANGE,
            values: ''
          },
          {
            index: 2,
            keyTitle: this.$t('unit.MMT.name'),
            keyType: 'SelectBox',
            class: '',
            keyRange: _MMT_GRADE_RANGE,
            values: ''
          },
          {
            index: 3,
            keyTitle: this.$t('unit.MRS.name'),
            keyType: 'SelectBox',
            class: '',
            keyRange: _MRS_RANGE,
            values: ''
          },
          {
            index: 4,
            keyTitle: this.$t('patient.condition.medicine'),
            keyType: 'DefaultInput',
            class: '',
            keyRange: [],
            values: '',
            maxLength: 50,
          }
        ];
        return {
          items: item,
          patientProps: '',
          activeSync: false,
          window: window
        }
      },
      methods: {
        ...mapActions(['modifyPatientInfo']),
        modalClose: function () {
          this.resetValue();
          this.$modal.hide('patient-condition-modal');
        },
        beforeOpen: function (event) {
          this.patientProps = event.params;
        },
        resetValue() {
          for (let item of this.items) {
            item.values = '';
          }
        },
        getValue() {
          return {
            seqPatient: this.patientProps.seqPatient,
            patientStatus: {
              createDatetime: '',
              seqPatientStatus: 0,
              seqMedicalRelation: this.patientProps.patientInfo.seqMedicalRelation,
              patientStatusParalysisPart: this.items[0].values ? this.items[0].values : undefined,
              patientStatusInfection: this.items[1].values.no,
              patientStatusMMT: this.items[2].values ? this.items[2].values.no : undefined,
              patientStatusMRS: this.items[3].values ? this.items[3].values.no : undefined,
              patientStatusMedication: this.items[4].values ? this.items[4].values : undefined
            }
          }
        },
        checkValues() {
          // 박스가 전부 빈 값이면 리턴
          const newData = this.getValue();
          const values = Object.values(newData.patientStatus);
          let undefinedVal = 0;

          for (let i = 0; values.length > i; i++) {
            if (values[i] === undefined) {
              undefinedVal = undefinedVal + 1;
            }
          }

          if (undefinedVal === 5) {
            this.$modal.show('common-alert-modal', {
              messageType: 'short',
              message: 'alert.at_least_one_required'
            });
            return
          }
          this.savePatientStatus(newData).catch(e => {
            console.error(`[patientCondition]${e}`)
          });
        },
        savePatientStatus(newData) {
          return new Promise((resolve, reject) => {
            this.activeSync = true;
            _API.PATIENT.appendPatientStatus(newData)
                .then(res => {
                  this.activeSync = false;
                  if (res.data.isSuccess) {
                    newData.patientStatus.createDatetime = this.moment().toISOString();
                    newData.patientStatus.seqPatientStatus = res.data.insertId;
                    this.modifyPatientInfo(newData);
                    this.$modal.show('common-alert-modal', {
                      messageType: 'short',
                      message: 'alert.save_completed'
                    });
                    this.$emit('getPatientStatusList');
                    this.modalClose();
                    resolve();
                  } else {
                    reject(`[savePatientStatus] add patient condition failed! ${res.data.failedCode}`);
                  }
                })
                .catch(e => {
                  this.activeSync = false;
                  reject(`[savePatientStatus]${e}`);
                });
          });
        }
      }
    }
</script>
<style lang="scss">
  .v--modal-overlay[data-modal="patient-condition-modal"] {

    .modal {
      max-width: 1000px;
      margin: 0 auto;

      .md_content {
        width: 350px;
        height: 560px;

        .table-container {
          grid-template-columns: 1fr;
          grid-template-rows: 82px;
          margin-bottom: 20px;

          .item-parent {
            flex-direction: column;
            align-items: baseline;
            .item-title {
              flex: 1 1 0;
              margin-bottom: 10px;
            }
          }

          .patient_info_value {
            width: 100%;
          }

          .v-select {
            height: 40px;
          }

          .vs__dropdown-menu {
            min-width: 115px;
            max-height: 140px;
          }

          flex-direction: column;

          .item-value {
            width: 100%;
          }
        }
      }
    }
  }
</style>


